<template>
  <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered>
    <template #modal-header>
      <div class="col-10">
        <h4>{{ $t('Insira os Serviços') }}!</h4>
      </div>
      <div class="col-2" style="justify-content: end; display: flex;">
        <button :disabled="disabledPeca" class="btn btn-success mb-2" @click="refreshItem()">
          <i class="fas fa-sync-alt"></i>
        </button>
      </div>
    </template>
    <div id="totalPecas">
      <add-servicos-component v-for="(item, index) in itensPecas" :key="index" :itemProp="item" :os="osTransfer"
        :nrConjunto="nr_conjunto" :index="index">
      </add-servicos-component>
    </div>
    <div class="container mt-4">
      <button class="btn btn-outline-secondary btn-block mb-2" @click="addPeca()">
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    </div>
 
    <template #modal-footer>
      <div class="w-100">
        <div class="row center" style="justify-content: center; ">
          <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModaServicos')">
            {{ $t('Fechar') }}
          </b-button>
          <b-button size="lg" v-if="exibeFinalizar" variant="success" @click="pararAtendimento">
            {{ $t('Finalizar OS') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import AddServicosComponent from './AddServicosComponent'

export default {
  name: 'ModalItems',
  props: {
    os: {},
    exibeFinalizar: {},
    item: {},
    nr_sequencial_servico: {},
    obsOS: {},
    valuesOsTransfered: {},
    tipo_os: {}
  },
  components: {
    AddServicosComponent
  },
  data() {
    return {
      selectServico: '',
      obsExterna: '',
      exibirItens: true,
      idConjunto: '',
      disabledPeca: true,
      disabledCancel: false,
      nr_conjunto: '',
      itensPecas: [],
      osTransfer: {}
    }
  },

  methods: {
    pararAtendimento() {

      const objOs = {
        nr_sequencial_servico: this.nr_sequencial_servico,
        obsOS: this.valuesOsTransfered.obsExterna,
        pneuAtendimento: {
          label: this.valuesOsTransfered.pneuAtendimento.label
        },
        pneuNovo: {
          nr_fogo: this.valuesOsTransfered.pneuNovo.nr_sequencial
        },
        km_atual: this.valuesOsTransfered.km_atual
      }

      if (this.valuesOsTransfered.precoTotal) {
        objOs.precoTotal = this.valuesOsTransfered.precoTotal
      }

      this.$emit('finalizaOS', { ...objOs })
    },

    refreshItem() {
      this.$store.dispatch('frotaItem/fetchFromMateriais', { nrOs: this.nr_conjunto })
    },
    addPeca() {
      this.disabledPeca = false
      this.disabledCancel = true
      this.itensPecas.push('')

      setTimeout(() => {
        let divTotalPecas = document.getElementById('totalPecas')

        divTotalPecas.scroll({
          top: 10000,
          left: 0,
          behavior: "smooth",
        });
      }, 100)

    },

    getInfOs() {
      this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
        this.nr_conjunto = response.data.nr_conjunto
        this.idConjunto = response.data.nr_conjunto

        var empresa = JSON.parse(localStorage.empresa)
        let filial = this.$store.getters['filial/filial']
        let filialCerta = ''

        if (filial.infColab.newFilial) {
          filialCerta = filial.infColab.newFilial
        } else {
          filialCerta = filial.nr_sequencial
        }

        const data = {
          nr_conjunto: this.nr_conjunto,
          nrOs: this.$route.params.id,
          empresa: empresa,
          filial: filialCerta,
          stOrigem: 'I',
          servico: true

        }

        if (response.data.st_origem == 'E') {
          data.stOrigem = 'E'
        }

        console.log(response.data)

        this.$store.dispatch('frotaItem/fetchFromMateriais', { data: data })
      }).catch(error => {
        console.log(error)
      })
    },

    getInfPreventiva() {
      var empresa = JSON.parse(localStorage.empresa)
      let filial = this.$store.getters['filial/filial']
      let filialCerta = ''

      if (filial.infColab.newFilial) {
        filialCerta = filial.infColab.newFilial
      } else {
        filialCerta = filial.nr_sequencial
      }

      const data = {
        nrOs: this.$route.params.id,
        empresa: empresa,
        filial: filialCerta,
        stOrigem: 'I',
        servico: true
      }

      // if (this.os.st_origem == 'E') {
      //   data.stOrigem = 'E'
      // }

      // console.log(this.os)

      this.$store.dispatch('frotaItem/fetchFromMateriais', { data: data })
    },

    getItens() {
      const data = {
        nr_os: this.$route.params.id,
        servico: true
      }

      this.$store.dispatch('frotaItem/fetchMateriaisOs', { data: data }).then(response => {
        this.itensPecas = response.data
      })
    }
  },

  created() {
    this.getItens()
    const data = {
      nrOs: this.$route.params.id,
      servico: true
    }
    this.$store.dispatch('frotaItem/fetchFromServicos', { data: data })
    if (this.tipo_os !== 'preventiva') {
      this.getInfOs()
      this.osTransfer = this.os
    } else {
      this.getInfPreventiva()
      this.osTransfer = this.os
    }
  },
}

</script>
<style scoped>
#modalItems {
  pointer-events: none !important;
  height: 750px !important;
}

.close {
  display: none !important;
}

#totalPecas {
  height: 340px !important;
  overflow-x: auto !important;
}

.modal-content {
  height: 700px !important;
}
</style>